var map = {
	"./BR.png": "1dfd",
	"./BR_round.png": "516d",
	"./CL.png": "8263",
	"./CL_round.png": "7615",
	"./CO.png": "43e4",
	"./CO_round.png": "1e4c",
	"./MX.png": "0a03",
	"./MX_round.png": "76e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c429";